import { Box, Flex, Progress } from '@chakra-ui/react';
import React from 'react';

const renderLoader = (progress: number) => {
  return (
    <Flex align='center' justify='center' h='600px'>
      <Box w='240px'>
        <Box textAlign='center'>Loading PDF file...</Box>
        <Progress hasStripe value={progress} />
      </Box>
    </Flex>
  );
};

export default renderLoader;
